/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=["animate","circle","defs","desc","ellipse","g","image","line","filter","marker","mask","metadata","path","pattern","polygon","polyline","rect","stop","switch","symbol","svg","text","tspan","use","view"];export{e as lowercaseSVGElements};
//# sourceMappingURL=lowercase-elements.js.map
